import React from 'react';
import { LEGAL_ENTITY_NAME, LEGAL_REGISTERED_ADDRESS, LEGAL_SUPPORT_EMAIL } from '../legalInfo';
import './Legal.css';

export const Terms = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1 className="legal-title">Terms &amp; Conditions</h1>
        <p className="legal-updated">Last updated: July 12, 2026</p>

        <div className="legal-section">
          <h2>Company Information</h2>
          <div className="legal-company-box">
            <p className="legal-entity-name">{LEGAL_ENTITY_NAME}</p>
            <p>Registered address: {LEGAL_REGISTERED_ADDRESS}</p>
            <p>Contact: <a href={`mailto:${LEGAL_SUPPORT_EMAIL}`}>{LEGAL_SUPPORT_EMAIL}</a></p>
          </div>
        </div>

        <div className="legal-section">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing or using the website and services provided by {LEGAL_ENTITY_NAME}
            ("we", "us", "our", "the Company"), you agree to be bound by these Terms &amp; Conditions.
            If you do not agree with any part of these terms, please discontinue use of our services.
          </p>
        </div>

        <div className="legal-section">
          <h2>2. Services</h2>
          <p>
            The Company provides enterprise AI agent development and related consulting services.
            Scope, deliverables, timelines, and fees for any engagement are set out in a separate
            written proposal or agreement between the Company and the client.
          </p>
        </div>

        <div className="legal-section">
          <h2>3. Payments</h2>
          <p>
            Where payments are collected through the website or via a payment gateway, all charges
            are processed in accordance with the pricing and payment terms communicated to you at the
            time of purchase. All payments are processed by {LEGAL_ENTITY_NAME}.
          </p>
        </div>

        <div className="legal-section">
          <h2>4. Intellectual Property</h2>
          <p>
            Unless otherwise agreed in writing, all content on this website, including text, graphics,
            logos, and software, is the property of {LEGAL_ENTITY_NAME} and is protected by
            applicable intellectual property laws.
          </p>
        </div>

        <div className="legal-section">
          <h2>5. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, {LEGAL_ENTITY_NAME} shall not be liable for
            any indirect, incidental, or consequential damages arising from your use of the website
            or services.
          </p>
        </div>

        <div className="legal-section">
          <h2>6. Governing Law</h2>
          <p>
            These Terms &amp; Conditions are governed by the laws of India, and courts in Tamil Nadu
            shall have exclusive jurisdiction over any disputes arising hereunder.
          </p>
        </div>

        <div className="legal-section">
          <h2>7. Contact &amp; Grievance</h2>
          <p>
            For any questions regarding these Terms, or to raise a grievance, please contact us at{' '}
            <a href={`mailto:${LEGAL_SUPPORT_EMAIL}`}>{LEGAL_SUPPORT_EMAIL}</a> or write to us at the
            registered address above.
          </p>
        </div>
      </div>
    </div>
  );
};
